<div class="relative" [ngClass]="isShowingGridView || isMobileView ? 'card-grid-view' : 'card-list-view'">
    @if (isFavourite) {
        <div class="absolute -top-3 -right-[0.8rem] z-10">
            <button type="button" (click)="onRemoveBookmark(courseListing.id)">
                <div class="bg-remove-red-rounded-icon icon-[2.125rem]"></div>
            </button>
        </div>
    }

    @if (!isShowingGridView && !isMobileView) {
        <div class="absolute right-4 top-4 z-10">
            <app-favourite
                [programId]="courseListing.id"
                [isFavourite]="courseListing.isFavorite"
                (favourite)="updateBookmarkUi()"></app-favourite>
        </div>
    }

    <div class="program-card-container flex" [ngClass]="{ 'flex-col': isShowingGridView || isMobileView, 'featured': courseListing.isFeatured}">
        <div class="card-cover-image-wrapper">
            <a [routerLink]="[courseListing.programRoute, courseListing.id]">
                <img
                    class="card-image"
                    alt="course cover image"
                    [src]="courseListing.attachmentUrl || GENERAL_IMAGE_PLACEHOLDER" />
            </a>

            @if (isCompleted) {
                <div
                    class="w-full h-full absolute top-0 left-0 z-10 bg-[#2c2c2c7a] rounded-2xl flex justify-center items-center">
                    <div class="bg-icon-green-completed icon-[6.375rem]"></div>
                </div>
            }

            @if ((!isFavourite && isShowingGridView) || isMobileView) {
                <div class="absolute -bottom-4 right-3 z-20">
                    <app-favourite
                        [programId]="courseListing.id"
                        [isFavourite]="courseListing.isFavorite"
                        (favourite)="updateBookmarkUi()"></app-favourite>
                </div>
            }

            @if (isShowTagging) {
                <div
                    class="absolute rounded-[8px] rounded-bl-none -top-[0.55rem] -left-[0.9rem] py-1 px-2"
                    [ngClass]="getUiProgramTag(courseListing.uiProgramType).backgroundColor">
                    <span class="text-[#FFF] text-sm font-semibold">
                        {{ getUiProgramTag(courseListing.uiProgramType).label | translate }}
                    </span>
                </div>
                <div
                    class="triangle absolute top-[1.4rem] -left-[0.9rem] w-0 h-0 border-r-0 border-t-[1rem] border-l-[1rem] border-transparent"
                    [ngClass]="getUiProgramTag(courseListing.uiProgramType).vectorCss"></div>
            }
        </div>
        <div class="card-info-container h-full">
            <div class="flex-shrink-0">
                <div class="card-header">
                    <div class="tag-container">
                        @if (topicUi) {
                            <button
                                #tooltip="matTooltip"
                                type="button"
                                class="tag cursor-pointer text-left !text-base !py-1 !px-[10px]"
                                [ngClass]="{ 'max-w-52': isMobileView }"
                                [matTooltip]="categories"
                                (click)="tooltip.toggle()">
                                {{ categories || '-' }}
                            </button>
                        } @else {
                            <div class="pill-black rounded-lg text-left ellipsis-line-1 !w-fit !py-1 !px-[10px]">
                                {{ getLongLanguageOptions(courseListing.language).label | translate }}
                            </div>
                        }

                        <div class="pill-yellow flex items-center flex-shrink-0 gap-x-2 !py-1 !px-[10px]">
                            <span class="inline-block class-info bg-clock-icon icon-[1rem]"></span>
                            <span class="ml-1 ellipsis-line-1">
                                {{ (courseListing.creditHours | number: '1.1-1') || 0 }}
                                {{ (courseListing.creditHours > 1 ? 'text.hoursFull' : 'text.hourFull') | translate }}

                                @if (courseListing.uiProgramType === UiProgramType.LiveWebinar) {
                                    <span class="inline-block w-0.5 border-r-[#6D4904] border-r-2 h-3 mx-1"></span>

                                    <span>
                                        {{ 'text.cpe' | translate }}
                                    </span>
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-content">
                    <div class="text-sm text-[#5F5B5B] !tracking-wider font-lato mb-1">
                        {{ 'text.published' | translate | uppercase }}
                        @if (getPublishedDate()) {
                            {{ getPublishedDate() | date: PUBLISHED_DATE_FORMAT | uppercase }}
                        }
                        @else {
                            -
                        }
                    </div>
                    <a
                        class="card-title"
                        [routerLink]="[courseListing.programRoute, courseListing.id]"
                        [innerHTML]="
                            courseListing.highlights?.title
                                | highlightText : courseListing.title : 'uppercase'
                        "></a>
                    <div class="card-description-container">
                        @if (courseListing.uiProgramType === UiProgramType.LiveWebinar) {
                            <div class="h-full flex items-center">
                                <div class="card-start-day-time-container">
                                    <div class="start-date">
                                        <span
                                            class="inline-block bg-blue-calendar-clock-icon icon-[1.5rem] mr-2"></span>
                                        <span>{{ courseListing.startDate | date: COURSE_DATE_FORMAT }}</span>
                                    </div>
                                    <div class="time flex items-center font-semibold text-default">
                                        <span *ngIf="!isShowingGridView" class="text-[0.6rem] font-bold mx-2">|</span>
                                        <span
                                            *ngIf="isShowingGridView"
                                            class="inline-block bg-blue-clock-icon icon-[1.5rem] mr-2"></span>
                                        <span>{{ courseListing.startDate | date: TWELVE_HOURS_FORMAT }}</span>
                                        <span class="mx-1">-</span>
                                        <span>{{ courseListing.endDate | date: TWELVE_HOURS_FORMAT }}</span>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="card-description">
                                <span>{{ courseListing.about }}</span>
                            </div>
                        }
                    </div>

                    <div class="card-speaker">
                        @if (isShowSpeaker && courseListing.speakerName) {
                            {{ 'courseListing.by' | translate }}
                            <a
                                class="text-[#00AFED] underline"
                                [routerLink]="['/resource/speaker/', courseListing.speakerId]"
                                >{{ courseListing.speakerName || '-' }}</a
                            >{{ ', ' + courseListing.speakerPosition || '-' }}
                        }
                    </div>
                </div>
            </div>
            <div class="flex-grow">
                @if (isShowProgressBar || isIllegibleForCertificate) {
                    <app-progress-bar
                        [progress]="courseListing.progress"
                        [ngClass]="{
                            'block h-10': isIllegibleForCertificate && !courseListing.isCertificateEnabled,
                        }"></app-progress-bar>
                }
                @if (isIllegibleForCertificate) {
                    @if (courseListing.isCertificateEnabled) {
                        <div class="w-full mt-3 flex space-x-2">
                            <mat-icon class="!h-[1.1rem] !w-4 flex-shrink-0" svgIcon="information"></mat-icon>
                            <span class="text-[#5F5B5B] text-[0.8rem] leading-tight">
                                {{ 'certificate.certificateEligibilityMessage' | translate }}
                            </span>
                        </div>
                    } @else {
                        <div class="w-full text-center mt-3">
                            <span class="text-[#5F5B5B] font-normal text-sm">
                                {{
                                    'text.attendedOn'
                                        | translate: { date: (courseListing.completedAt | date: 'dd/MM/yyyy') }
                                }}
                            </span>
                        </div>
                    }
                }

                <div
                    *ngIf="!isIllegibleForCertificate"
                    class="card-footer"
                    [ngClass]="{ 'mt-[1.4rem]': !isShowingGridView }">
                    <app-program-button
                        class="card-action-button"
                        [certificateId]="courseListing.certificateAttachmentId"
                        [completedAt]="courseListing.completedAt"
                        [isEnrol]="courseListing.isEnrol"
                        [isProgramExpired]="courseListing.isProgramExpired"
                        [isProgramJoinable]="courseListing.isProgramJoinable"
                        [isLearningInProgress]="courseListing.progress > 0"
                        [isLearningCompleted]="courseListing.progress === 100"
                        [programRoute]="courseListing.programRoute"
                        [programId]="courseListing.id"
                        [uiProgramType]="courseListing.uiProgramType"
                        [willIncludeRecording]="courseListing.willIncludeRecording"
                        [isMeetingEnded]="courseListing.isMeetingEnded"
                        [details]="courseListing"
                        (buttonClick)="closeMobilePopupCard()"></app-program-button>

                    @if (isShowProgramLiveStatus) {
                        <div
                            class="flex justify-center items-center text-[#00AFED]"
                            [ngClass]="{ 'mt-[1.125rem]': isShowingGridView }">
                            @if (!courseListing.isProgramJoinable) {
                                <mat-icon svgIcon="clock-line" class="!w-4"></mat-icon>
                                <span class="ml-1 font-semibold">
                                    <countdown [config]="config" />
                                </span>
                            } @else {
                                @if (courseListing.isInProgress) {
                                    <div class="btn-live">
                                        {{ 'text.live' | translate }}
                                        <img class="w-[1.5rem] ml-1" alt="live" src="/assets/images/live.gif" />
                                    </div>
                                } @else {
                                    @if (courseListing.isEnrol){
                                        <div class="bg-clock-gray-icon icon-[1rem]"></div>
                                        <span class="ml-2 font-semibold text-[#817F7F]">
                                            {{ 'text.waitingForHost' | translate }}
                                        </span>
                                    }
                                }
                            }
                        </div>
                    }

                    @if (isCompleted) {
                        <div class="w-full text-center mt-3">
                            <span class="text-[#5F5B5B] font-normal text-sm">
                                {{
                                    'text.completedAt'
                                        | translate: { date: (courseListing.completedAt | date: 'dd/MM/yyyy') }
                                }}
                            </span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
